"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_interchangable__batteries(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "4ccf1f72-9166-4440-ad92-d52a6205fde5",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "88b290f8-bc2b-47e5-af48-3aadbf500f26",
    x1: 100,
    y1: 31.86,
    x2: 132.1,
    y2: 31.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdbdbd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c4cee171-ebc3-466c-8a85-8474d49e1b15",
    x1: 106.08,
    y1: 63.33,
    x2: 106.08,
    y2: 63.33,
    xlinkHref: "#88b290f8-bc2b-47e5-af48-3aadbf500f26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "269c8043-08c3-4c7d-b1a1-e1f87d898105",
    x1: 85.97,
    y1: 95.79,
    x2: 148,
    y2: 95.79,
    xlinkHref: "#88b290f8-bc2b-47e5-af48-3aadbf500f26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2f125b65-b839-4a4a-8024-5254cd06c5d0",
    x1: 59.97,
    y1: 47.86,
    x2: 92.07,
    y2: 47.86,
    xlinkHref: "#88b290f8-bc2b-47e5-af48-3aadbf500f26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e0eb5403-4630-452c-ab80-9f6452325fea",
    x1: 43.94,
    y1: 111.87,
    x2: 108.06,
    y2: 111.87,
    xlinkHref: "#88b290f8-bc2b-47e5-af48-3aadbf500f26"
  })), /*#__PURE__*/React.createElement("title", null, "interchangable-batteries-hi"), /*#__PURE__*/React.createElement("path", {
    d: "M132.1,40V30.3a6.58,6.58,0,0,0-6.57-6.58h-19A6.58,6.58,0,0,0,100,30.3V40Z",
    transform: "translate(0)",
    fill: "url(#88b290f8-bc2b-47e5-af48-3aadbf500f26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.1,40V30.3a6.58,6.58,0,0,0-6.57-6.58h-19A6.58,6.58,0,0,0,100,30.3V40Z",
    transform: "translate(0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.08,21.51",
    transform: "translate(0)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.08,21.51",
    transform: "translate(0)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.08,63.33",
    transform: "translate(0)",
    fill: "url(#c4cee171-ebc3-466c-8a85-8474d49e1b15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,39.72h52.17A9.86,9.86,0,0,1,148,49.59V142a9.86,9.86,0,0,1-9.86,9.86H108.06",
    transform: "translate(0)",
    fill: "url(#269c8043-08c3-4c7d-b1a1-e1f87d898105)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.07,56V46.3a6.59,6.59,0,0,0-6.58-6.58H66.54A6.58,6.58,0,0,0,60,46.3V56Z",
    transform: "translate(0)",
    fill: "url(#2f125b65-b839-4a4a-8024-5254cd06c5d0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.07,56V46.3a6.59,6.59,0,0,0-6.58-6.58H66.54A6.58,6.58,0,0,0,60,46.3V56Z",
    transform: "translate(0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.06,142.64v15.5A9.86,9.86,0,0,1,98.2,168H53.8a9.86,9.86,0,0,1-9.86-9.86V65.6a9.86,9.86,0,0,1,9.86-9.86H98.2a9.86,9.86,0,0,1,9.86,9.86v77Z",
    transform: "translate(0)",
    fill: "url(#e0eb5403-4630-452c-ab80-9f6452325fea)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.94,77.72h6v6a2,2,0,0,0,4,0v-6h6a2,2,0,0,0,0-4h-6v-6a2,2,0,0,0-4,0v6h-6a2,2,0,0,0,0,4Z",
    transform: "translate(0)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.94,149.72h-16a2,2,0,0,0,0,4h16a2,2,0,0,0,0-4Z",
    transform: "translate(0)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.19,101.63h0a2,2,0,0,0-2,2,24.1,24.1,0,0,1-24.07,24h0a24.11,24.11,0,0,1-24-24.07v-7l8.74,8.77a2.06,2.06,0,0,0,1.44.59,2,2,0,0,0,1.43-3.45L77.42,90.3h0a1.42,1.42,0,0,0-.3-.25L77,90l-.21-.11a1.39,1.39,0,0,0-.19-.06l-.19-.06a2.71,2.71,0,0,0-.4,0h0a2.58,2.58,0,0,0-.4,0l-.22.07-.16,0L75,90l-.15.09a1,1,0,0,0-.2.16l-.11.08-12,12a2,2,0,1,0,2.87,2.87L74,96.62v7a28.16,28.16,0,0,0,28.09,28.12h0a28.15,28.15,0,0,0,28.12-28.09A2,2,0,0,0,128.19,101.63Z",
    transform: "translate(0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.18,104.27a2,2,0,0,1-1.43-.6L78,94.91v1.72l8.74,8.77A2,2,0,0,0,90,103.1a2,2,0,0,1-.39.57A2,2,0,0,1,88.18,104.27Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.37,103.48a2,2,0,0,1-2.87,0,2,2,0,0,1-.39-.57,2,2,0,0,0,3.26,2.3L74,96.62V94.89Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.08,130h0A28.16,28.16,0,0,1,74,101.9v1.73a28.17,28.17,0,0,0,28.09,28.12h0a28.16,28.16,0,0,0,28.13-28.09,2.2,2.2,0,0,0,0-.36A28.16,28.16,0,0,1,102.08,130Z",
    transform: "translate(0)"
  })));
}

var _default = ic_interchangable__batteries;
exports.default = _default;